/**
 * Util function for creating sizes based on the profile grid.
 * Takes the form a of function to be consistent with Atlaskit theme grid sizes.
 */
export const profileGridSizeTimes = (n: number): number => 80 * n;

/**
 * Using ADG3 comfortable spacing -> 40px gutters
 * 20px half gutters used as padding around columns -> adjacent columns are 40px apart.
 */
export const halfGutterSize = 20;

/* Minimum width columns are allowed to be */
export const minColumnWidth: number = profileGridSizeTimes(3);

/**
 * Minimum page width for non-responsive pages: 768px
 * From Atlassian Cloud minimum screen size:
 * https://confluence.atlassian.com/cloud/supported-browsers-744721663.html
 */
export const responsiveContentWidthThreshold = 768;

/**
 * Threshold width where layout switches between narrow and standard views.
 *
 *   768 (Min page layout content width) +
 *    64 (width of global nav) +
 * +  34 (Total unavoidable ancentral padding-left/margin-left)
 * = Responsive threshold width
 */
export const responsiveThreshold = responsiveContentWidthThreshold + 64;
